import * as React from 'react';

interface IRRuler {
  rulerList?: number[]
  width?: number
  className?: string
  changemargin?: (value: number, index: number) => void
}

class Ruler extends React.Component<IRRuler>{

  state = {
    disX: 0,
    needX: 100,
  }
  RulerSize = React.createRef<HTMLDivElement>()

  public fnDown = (e: any, index: number, margin: number, width: number) => {

    const event = e || window.event;
    const target = event.currentTarget || event.srcElement;
    margin = margin || 0
    width = width || 0
    this.state.disX = event.clientX - target.offsetLeft + margin - width
    document.onmousemove = this.fnMove.bind(this, false, index);
    document.onmouseup = this.fnUp.bind(this, false, index);
  }


  public fnMove = (e: any, index: number) => {
    const event = e || window.event;
    index = index || 0
    this.state.needX = event.clientX - this.state.disX > 0 ? event.clientX - this.state.disX : 0;
    this.props.changemargin(this.state.needX, index)
  }


  public fnUp = () => {
    document.onmousemove = null;
    document.onmouseup = null;
  }

  renderIcon(margin: number, index: number, width: number) {
    return (
      <div className="Ruler-div" style={{ left: margin || 0 }} onMouseDown={(e) => this.fnDown(e, index, margin, width)} key={index} >
        <div className="Ruler-data" > {width} </div>
        <div className="Ruler-Icon" />
      </div>

    )
  }

  public render() {
    const rulerList = this.props.rulerList || []
    let Rwidth = this.props.width + ''
    if (this.RulerSize.current) {
      Rwidth = this.RulerSize.current.offsetWidth > this.props.width ? this.RulerSize.current.offsetWidth + 'px' : this.props.width + 'px'
    }
    let margin = 0
    return (
      <div className={`Ruler ${this.props.className}`} ref={this.RulerSize} style={{ width: Rwidth || '100%' }}>{rulerList.map((width: number, index: number) => {
        margin = margin + width
        return this.renderIcon(margin, index, width)
      }
      )}
      </div>
    );
  }
}

export default Ruler;



// WEBPACK FOOTER //
// ./src/components/AppRuler/Ruler.tsx